import { Ingredient } from 'types/ingredient';

export const ingredients: Ingredient[] = [
  {
    name: 'Flour',
    id: '9ea5e96d-6586-4fcf-bff7-81742a095649',
  },
  {
    name: 'Onion',
    id: '651eb640-b057-4275-9d8b-56f1c30a494e',
  },
  {
    name: 'Pumpkin',
    id: '0a1f87d2-333b-4b43-97dd-d37bdd04aff8',
  },
  {
    name: 'Mixed Salad Leaves',
    id: '317fdc02-ad3c-4e05-87d0-d77144aea36c',
  },
  {
    name: 'Chicken Slices',
    id: 'e880745e-3d0f-4e92-a287-c79be26e745e',
  },
  {
    name: 'Potatoes',
    id: '782ccfbd-391a-4923-965c-00207569a280',
  },
  {
    name: 'Mushrooms',
    id: 'ed40bf7c-40cb-4015-b4a0-620fbea71d8f',
  },
  {
    name: 'Breadcrumbs',
    id: 'b7ba3647-7f5a-47af-90e2-d7e0de93422b',
  },
  {
    name: 'Yoghurt',
    id: 'c25e85d4-98e6-4921-b99d-e253507f5fa0',
  },
  {
    name: 'Beef Mince',
    id: '8b23a31e-811e-4dd3-94ae-ff595c430e53',
  },
  {
    name: 'Capsicum',
    id: '5a06d9d3-efdf-4b41-9cea-baf3cc73dafb',
  },
  {
    name: 'Broccoli',
    id: '93627fa4-55da-4a7e-a2f1-96e9ea0a0c1a',
  },
  {
    name: 'Cherry Tomatoes',
    id: '63d1be1b-15f4-4e2e-9e3c-9f0280421cca',
  },
  {
    name: 'Milk',
    id: 'dfe94941-5f7a-42f7-93a9-9b4247ede351',
  },
  {
    name: 'Bananas',
    id: '6ac8e775-54ca-4c56-a2b6-ac29a922618d',
  },
  {
    name: 'Chicken Schnitzel',
    id: '04fe0f59-a6a1-40f4-b3e8-ba9f609103d0',
  },
  {
    name: 'Eggs',
    id: '950a2377-af02-4877-bf4b-fdc69fed1447',
  },
  {
    name: 'Bread',
    id: '2dafbf15-966f-49ff-8e14-5b68eb1dd7a5',
  },
  {
    name: 'Salami',
    id: 'b475cb8b-0b31-4922-a4b8-1e67004746fe',
  },
  {
    name: 'Chinese Vegetables',
    id: '5565d88d-04d5-4991-b727-e6a6d69df6a2',
  },
  {
    name: 'Spinach Leaves',
    id: '1ee26204-9f3a-4a14-b2c9-19835634e490',
  },
  {
    name: 'Carrots',
    id: 'b2450dd0-cef9-49b1-8ef7-bd45f0edf97f',
  },
  {
    name: 'Pasta',
    id: 'b2450dd0-cef9-49b1-8ef7-bd45f0edf97f',
  },
  {
    name: 'Canned Tomatoes',
    id: 'c75b30e1-058e-48aa-a973-5e9ff64f8001',
  },
  {
    name: 'Cheese',
    id: 'c51c0951-6298-435d-8e5a-92f9417b1bf9',
  },
  {
    name: 'Mince (Beef)',
    id: '811af15c-e37e-47ca-b345-348512fcceb0',
  },
  {
    name: 'Broccolini',
    id: '2b70e615-8afd-40e0-9647-bbddac0de08d',
  },
  {
    name: 'Weet-Bix',
    id: 'b27ab940-325b-4a7f-94a2-4f3e48b7a436',
  },
  {
    name: 'Tomatoes',
    id: '0d703b12-6357-48f9-a298-a7a1a13423c2',
  },
];
